import {hasCancelRequest} from "@/helpers/common";
import { email } from "@/helpers/auth";

const actions = {
  async setUserPremiumPlanInformation({ commit }) {
    const that = this._vm;
    const url = "v1/user/ispremium";

    try {
      const response = await that.$constants('$http').get(url);
      commit("setUserPremiumPlanInformation", response.data.data)
      commit('common/setApisLoadStates', { api: 'userPremiumPlan', isLoaded: true }, { root: true });
    } catch (error) {
      const notification = {
        code: "urgent",
        title: "An error occurred during fetching the user premium plan information. Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true })
    }
  },
  async setClientPremiumPlan({state, commit, rootGetters }) {
    const that = this._vm;
    const clientID = rootGetters['common/getActiveClientID'];
    const url = `v1/clients/${clientID}/ispremium`;
    let isClientPremium = null;

    try {
      const response = await that.$constants('$http').get(url)
      isClientPremium=response.data.data;
      commit("setClientPremiumPlan", isClientPremium)
      commit('common/setApisLoadStates',{api:'clientPremiumPlan',isLoaded:true},{root:true});
    }catch (error) {
      if (hasCancelRequest(error))return;
      const notification={
        code:"urgent",
        title:"An error occurred during fetching the client premium plan.Please refresh the page and try again.",
      }
      commit("notifications/setNotification",notification,{root:true})
    }
  },
  async setBillingInformation({ state, commit }) {
    const that = this._vm;
    const data = {
      email: email()
    };
    const url = "v1/user/tier-informations";
    const config = { params: data };

    commit('common/setApisLoadStates', { api: 'billingInformation', isCalled: true }, { root: true });

    try {

      const response = await that.$constants('$http').get(url, config);
      commit('setBillingInformation', response.data.data);

    } catch (error) {

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching the user billing information.Please refresh the page and try again.",
      }
      commit("notifications/setNotification", notification, { root: true });

    } finally {
      commit('common/setApisLoadStates', { api: 'billingInformation', isLoaded: true }, { root: true });
    }
  },
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js